module["exports"] = [
  "Canada"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/fr_CA/address/default_country.js
// module id = 1157
// module chunks = 1